<template>
  <div class="vx-row my-5 flex items-center justify-center">
    <div class="vx-col my-5 flex justify-center" :class="classesStr">
      <!-- Linked image: the anchor is the interactive element. No caller passes both
           `link` and @clicked, so these branches never overlap. -->
      <a :href="link" v-if="link" target="_blank">
        <img :src="image" :alt="alt" class="img-responsive" />
      </a>

      <!-- Clickable image: was an <img alt="" > with a @click handler, so it could not be reached
           or activated by keyboard (WCAG SC 2.1.1). A real <button> carries the role and
           the accessible name; the image inside is then decorative (SC 4.1.2). -->
      <button
        v-else-if="isClickable"
        type="button"
        class="no-style img-button mx-auto"
        :aria-label="label"
        @click="$emit('clicked')"
      >
        <img :src="image" alt="" class="img-responsive" />
      </button>

      <img v-else :src="image" :alt="alt" class="img-responsive mx-auto" />
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    image: { type: String, required: true },
    link: { type: String, default: '' },
    classes: { type: String, default: undefined },
    // Accessible name for the button form. The image inside is marked decorative, so
    // without this the control would have no name at all.
    label: { type: String, default: 'View larger image' },
    // Alternative text for the non-interactive and linked forms.
    alt: { type: String, default: '' },
  },
  computed: {
    isClickable() {
      return !!this.$listeners.clicked;
    },
    // Unchanged from the original: 120 call sites depend on these exact mappings.
    classesStr() {
      if (typeof this.$props.classes !== 'undefined') {
        if (this.$props.classes == '1/2') return 'xl:w-1/2 lg:w-2/3 w-full';
        if (this.$props.classes == '2/3') return 'xl:w-2/3 lg:w-3/4 w-full';
        else return this.$props.classes;
      } else return 'xl:w-1/3 lg:w-1/2 w-full';
    },
  },
};
</script>

<style scoped>
.img-button {
  display: block;
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
}
</style>
